import { Head, Link } from "@inertiajs/react"
import { Link2, Plus, Rocket } from "lucide-react"

import { Button } from "@/components/ui/button"
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import AppLayout from "@/layouts/app-layout"

interface CampaignItem {
  id: number
  title: string
  slug: string
  status?: string
  base_entries?: number
  entries_per_referral?: number
  host?: { id: number; title: string }
}

interface Props {
  campaigns: CampaignItem[]
}

export default function ViralCampaignsIndex({ campaigns }: Props) {
  return (
    <AppLayout title="Campañas virales">
      <Head title="Campañas virales" />

      <div className="mx-auto max-w-6xl space-y-6 p-4 md:p-6">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex items-center gap-2">
            <Rocket className="text-primary h-7 w-7" />
            <h1 className="text-2xl font-bold md:text-3xl">Campañas virales</h1>
          </div>
          <Link href="/viral/campaigns/new">
            <Button>
              <Plus className="mr-2 h-4 w-4" /> Nueva campaña
            </Button>
          </Link>
        </div>

        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
          {campaigns.map((c) => (
            <Card key={c.id}>
              <CardHeader>
                <CardTitle className="flex items-center justify-between gap-2">
                  <span className="truncate">{c.title}</span>
                  {c.status && (
                    <span className="bg-muted rounded px-2 py-0.5 text-xs uppercase">
                      {c.status}
                    </span>
                  )}
                </CardTitle>
              </CardHeader>
              <CardContent className="space-y-3">
                <div className="text-muted-foreground text-sm">
                  <div>
                    Slug: <span className="font-mono">{c.slug}</span>
                  </div>
                  {typeof c.base_entries !== "undefined" &&
                    typeof c.entries_per_referral !== "undefined" && (
                      <div>
                        Entradas base: {c.base_entries} — Por referido: +
                        {c.entries_per_referral}
                      </div>
                    )}
                  {c.host && (
                    <div className="flex items-center gap-1">
                      <Link2 className="h-3.5 w-3.5" />
                      <span className="text-xs">
                        Asociada a sorteo: {c.host.title}
                      </span>
                    </div>
                  )}
                </div>

                <div className="flex gap-2">
                  <Link href={`/viral/campaigns/${c.id}/edit`}>
                    <Button variant="outline" size="sm">
                      Editar
                    </Button>
                  </Link>
                  <Link href={`/sorteo/${c.slug}`}>
                    <Button variant="secondary" size="sm">
                      Ver landing
                    </Button>
                  </Link>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </AppLayout>
  )
}
